declare namespace $ {

	type $mol_view__sub_shm_hitalama_process_monitor_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__hint_shm_hitalama_process_monitor_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_hitalama_process_monitor_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor['exclude_substr'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_pick__trigger_content_shm_hitalama_process_monitor_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_hitalama_process_monitor_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_button_minor__hint_shm_hitalama_process_monitor_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_process_monitor_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_process_monitor_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_search__query_shm_hitalama_process_monitor_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor['menu_filter'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_paragraph__title_shm_hitalama_process_monitor_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor['process_duration'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__style_shm_hitalama_process_monitor_11 = $mol_type_enforce<
		({ 
			'width': ReturnType< $shm_hitalama_process_monitor['process_duration_width'] >,
		})  & ReturnType< $mol_paragraph['style'] >
		,
		ReturnType< $mol_paragraph['style'] >
	>
	type $mol_button_minor__click_shm_hitalama_process_monitor_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor['detail_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_process_monitor_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_dimmer__needle_shm_hitalama_process_monitor_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor['menu_filter'] >
		,
		ReturnType< $mol_dimmer['needle'] >
	>
	type $mol_dimmer__haystack_shm_hitalama_process_monitor_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor['spread_title'] >
		,
		ReturnType< $mol_dimmer['haystack'] >
	>
	type $mol_view__style_shm_hitalama_process_monitor_16 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_hitalama_process_monitor['process_status_color'] >,
			'backgroundColor': ReturnType< $shm_hitalama_process_monitor['process_status_tint'] >,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_hitalama_process_monitor_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_process_monitor_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor['widget_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_process_monitor_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__attr_shm_hitalama_process_monitor_20 = $mol_type_enforce<
		({ 
			'shm_hitalama_process_monitor_current': ReturnType< $shm_hitalama_process_monitor['detail_current'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_hitalama_process_monitor_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_tree__roots_shm_hitalama_process_monitor_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor['root_process_ids'] >
		,
		ReturnType< $shm_tree['roots'] >
	>
	type $shm_tree__children_shm_hitalama_process_monitor_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor['process_children'] >
		,
		ReturnType< $shm_tree['children'] >
	>
	type $shm_tree__expanded_shm_hitalama_process_monitor_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor['process_expanded'] >
		,
		ReturnType< $shm_tree['expanded'] >
	>
	type $shm_tree__Item_shm_hitalama_process_monitor_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor['Menu_item'] >
		,
		ReturnType< $shm_tree['Item'] >
	>
	type $mol_page__title_shm_hitalama_process_monitor_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor['menu_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_shm_hitalama_process_monitor_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor['menu_tools'] >
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_hitalama_process_monitor_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_hitalama_process_monitor_detail__key_shm_hitalama_process_monitor_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor['key'] >
		,
		ReturnType< $shm_hitalama_process_monitor_detail['key'] >
	>
	type $shm_hitalama_process_monitor_detail__close_shm_hitalama_process_monitor_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor['detail_close'] >
		,
		ReturnType< $shm_hitalama_process_monitor_detail['close'] >
	>
	export class $shm_hitalama_process_monitor extends $mol_book2 {
		Exclude_icon( ): $mol_icon_filter_off
		Exclude_label( ): $mol_view
		exclude_substr( next?: string ): string
		Exclude_input( ): $mol_string
		Exclude_filter( ): $mol_pick
		Close_icon( ): $mol_icon_close
		Close( ): $mol_button_minor
		Menu_title( ): ReturnType< ReturnType< $shm_hitalama_process_monitor['Menu'] >['Title'] >
		Menu_tools( ): ReturnType< ReturnType< $shm_hitalama_process_monitor['Menu'] >['Tools'] >
		menu_filter( next?: string ): string
		Menu_filter( ): $mol_search
		root_process_ids( ): readonly(any)[]
		process_children( id: any): readonly(any)[]
		process_expanded( id: any, next?: boolean ): boolean
		detail_current( id: any): boolean
		detail_click( id: any, next?: any ): any
		process_duration( id: any): string
		process_duration_width( id: any): string
		Process_duration( id: any): $mol_paragraph
		Menu_detail( id: any): $mol_button_minor
		widget_click( id: any, next?: any ): any
		Menu_link_title( id: any): $mol_dimmer
		Menu_link_status( id: any): $mol_view
		Menu_widget( id: any): $mol_button_minor
		Menu_item( id: any): $mol_view
		Menu_links( ): $shm_tree
		Menu( ): $mol_page
		detail_close( id: any, next?: any ): any
		key_default( ): string
		menu_title( ): string
		close( next?: any ): any
		spread( next?: string ): string
		menu_tools( ): readonly(any)[]
		pages( ): readonly(any)[]
		spread_current( ): any
		spread_title( id: any): string
		process_status_color( id: any): string
		process_status_tint( id: any): string
		Page( id: any): $shm_hitalama_process_monitor_detail
		key( id: any): ReturnType< $shm_hitalama_process_monitor['key_default'] >
	}
	
}

//# sourceMappingURL=monitor.view.tree.d.ts.map